import axios from "axios";
import { getAuthHeader } from "../utils/AuthUtils";
import { Response } from "../types";
import { DesignState, Palette, Team } from "../types";

const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_ROUTE = "/api/v1/templates";

interface GenerateTemplateResponse {
  targetTeam: Team;
  summary: {
    totalPalettes: number;
    successful: number;
    failed: number;
  };
}

class TemplateService {
  static async getTemplates(paletteId: number) {
    return axios.get<Response<DesignState[]>>(
      `${USER_API_BASE_URL}${BASE_ROUTE}/palettes/${paletteId}/designs`,
      getAuthHeader()
    );
  }

  static async getPalettes() {
    return axios.get<Response<Palette[]>>(
      `${USER_API_BASE_URL}${BASE_ROUTE}/palettes`,
      getAuthHeader()
    );
  }

  static async regenerateTemplate(
    sourceTeamId: string,
    options: { fireAndForget?: boolean } = {}
  ) {
    const config = {
      ...getAuthHeader(),
      timeout: options.fireAndForget ? 0 : 30000, // No timeout for fire-and-forget
      retries: options.fireAndForget ? 0 : 3, // Disable retries for fire-and-forget
    };

    return axios.post<Response<GenerateTemplateResponse>>(
      `${USER_API_BASE_URL}${BASE_ROUTE}/generate`,
      { sourceTeamId },
      config
    );
  }
}

export default TemplateService;
